<template>
  <div class="grid">
    <div class="grid__wrapper">
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
  .grid {
    padding: 0 em(20);
    width: 100%;

    @include responsive(md) {
      margin: 0 auto;
      max-width: var(--grid_width);
    }
  }
  .grid__wrapper {
    display:flex;
    flex-direction: column;

    @include responsive(xs) {
      margin: 0 calc(var(--grid_gutter) * -1);
      display:flex;
      flex-wrap:wrap;
      flex-grow:1;
      flex-direction: row;
    }
  }
</style>
